import { i18nConfig } from '@/i18n/config.js'
import { getLanguage, langArr, langRouterLangMap, routerLangMap, setLanguage } from '@/i18n/lang'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'

const LanguageLayout = () => {
  const { i18n } = useTranslation()
  const navigator = useNavigate()
  // 处理语言
  // 路由传参/:lang/home
  const urlParams = useParams<{ routerLang: string }>()
  const { routerLang } = urlParams
  // URL传参
  const [searchParams] = useSearchParams()
  const location = useLocation()

  /**
   * 处理H5 SEO路由
   * 兼容历史url传参
   */
  const handleSeoRouter = () => {
    const _routerLangMap: any = routerLangMap
    const _langRouterLangMap: any = langRouterLangMap
    const queryParams = Object.fromEntries(searchParams.entries())
    const queryLang: string = queryParams.langH5 || ''
    let url = location.pathname === '/' ? '/home' : location.pathname
    let urlParams: string = ''
    // url传参
    if (location.search) {
      urlParams =
        '?' +
        Object.keys(queryParams)
          .filter((key) => key !== 'langH5')
          .map((key) => `${key}=${queryParams[key]}`)
          .join('&')
    }
    if (queryLang && langArr.includes(queryLang || '')) {
      // URL传参匹配后，转为路由传参
      if (routerLang) {
        // 如果路由已有routerLang，先清除，优先取queryLang
        url = url.replace(`/${routerLang}`, '')
      }
      if (_langRouterLangMap[queryLang]) {
        url = `/${_langRouterLangMap[queryLang]}${url}`
      }
      navigator(`${url}${urlParams}`, { replace: true })
    } else if (routerLang && _routerLangMap[routerLang]) {
      // 路由语言传参
      setLanguage(_routerLangMap[routerLang])
    } else {
      // 未匹配, 使用默认路由
      if (['', '/'].includes(url)) {
        return
      }
      const pathNameArr = url.split('/')
      if (_routerLangMap[pathNameArr[1]]) {
        url = `/${pathNameArr[1]}/home`
      } else {
        let lang = getLanguage()
        lang = _langRouterLangMap[lang] || langRouterLangMap[i18nConfig.defaultLang]
        url = `/${lang}${url}`
      }
      navigator(`${url}${urlParams}`, { replace: true })
    }
  }
  useEffect(() => {
    handleSeoRouter()
  }, [])

  useEffect(() => {
    const pathname = location.pathname.replace(`/${routerLang}`, '')
    const search = location.search
    const url = pathname + search
    if (url !== '' && url !== '/') {
      navigator(`/${langRouterLangMap[i18n.language]}${url}`, { replace: true })
    }
  }, [i18n.language, location.pathname])

  return (
    <div>
      <Outlet key={i18n.language} />
    </div>
  )
}

export default LanguageLayout
